export default __webpack_public_path__ + "media/trail/icons-controls-zoom-in-7febda2a.svg";